<script setup>
import { inject, computed } from 'vue'

const props = defineProps({
  title:   { type: String, default: '' },
  colspan: { type: [Number, String], default: null },
})

const injectedColspan = inject('reportTableColspan', computed(() => 1))
const resolvedColspan = computed(() => props.colspan ?? injectedColspan.value)
</script>

<template lang="pug">
tr.no-bottom-border
  td.px-0.py-0(:colspan="resolvedColspan")
    .p-3.bg-canvas-200.flex-between
      .text-lg.font-semibold {{ title }}
      .text-lg.font-semibold
        slot
</template>
